'use strict';

var _product = require('../modules/product.js');

(0, _product.addToCartListener)();
(0, _product.upgradeData)();